const findTextNode = node => {
  if (node.nodeType === Node.TEXT_NODE && node.textContent && node.textContent.trim().length > 0) {
    return node;
  }
  for (let i = 0; i < node.childNodes.length; i++) {
    const foundNode = findTextNode(node.childNodes[i]);
    if (foundNode) {
      return foundNode;
    }
  }
  return null;
};
export const calculateLineHeightClosestChild = element => {
  const textNode = findTextNode(element);
  if (textNode && textNode.parentElement) {
    const computedStyle = window.getComputedStyle(textNode.parentElement);
    return parseInt(computedStyle.lineHeight, 10);
  }
  return 0;
};